import React from "react";
import { FormattedMessage } from "react-intl";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { Page, CardBody, CardTitle } from "@ui/Page";
import { compose } from "@util/compose";
import { messages as vMessages } from "@vendor/messages";
import { Playlist as Model } from "@vendor/models";
import { OwnedTracksList } from "@vendor/components/OwnedTracksList";
import { PlaylistsFilters } from "@vendor/components/PlaylistsFilters";

const breadcrumbItems = [
    { text: <FormattedMessage {...messages.pagePlaylistsTitle} /> },
];

const PlaylistsIndex = ({ history }: RouteComponentProps) => {
    const onFilter = (id: number) => {
        const playlist = new Model({id});
        history.push(playlist.getViewUrl());
    };
    return (
        <Page className="playlists-index-page" breadcrumbs={breadcrumbItems}>
            <CardBody>
                <CardTitle tag="h1">
                    <FormattedMessage {...messages.pagePlaylistsTitle} />
                </CardTitle>
                <PlaylistsFilters onFilter={({ id }) => onFilter(id)} />
                <CardTitle tag="h2">
                    <FormattedMessage {...vMessages.tracksOnPlaylists} />
                </CardTitle>
            </CardBody>
            <OwnedTracksList />
        </Page>
    );
};

const ConnectedPlaylistsIndex = compose<RouteComponentProps, {}>(
    withRouter,
    setTitleOnPage(messages.pagePlaylistsTitle),
)(PlaylistsIndex);

export {
    PlaylistsIndex as PlaylistsIndexPresenter,
    ConnectedPlaylistsIndex as PlaylistsIndex,
};
